import React, { useEffect, useRef, useState } from 'react';
import Wrapper from "./Wrapper";
import logo from '../assets/Images/logo.svg';
import { Link } from 'react-router-dom';
import HamburgerMenu from "./HamburgerMenu"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Header = () => {
    const headerRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (headerRef.current) {
                const stickyThreshold = headerRef.current.offsetHeight;
                setIsSticky(window.scrollY > stickyThreshold);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navItems = [
        { label: 'بلاگ', to: '/blog/' }
    ];

    return (
        <>
            <header
                ref={headerRef}
                className={`w-full py-2 z-50 transition-all backdrop-blur-sm duration-300 ${
                    isSticky ? 'fixed top-0 left-0 bg-white/70 shadow-md' : 'relative'
                }`}
            >
                <Wrapper className="flex relative items-center justify-between md:justify-start">
                    {/* Hamburger menu: Right on small screens */}
                    <HamburgerMenu
                        navItems={navItems}
                        className="ml-auto relative inline-block order-1 md:order-2"
                    />

                    {/* Logo: Centered on mobile, start on md+ */}
                    <Link
                        to="/"
                        className="absolute left-1/2 -translate-x-1/2 md:relative md:left-0 md:translate-x-0 flex order-2 md:order-1 items-center"
                    >
                        <img src={logo} alt="Logo" className="h-12 rounded-sm ml-2" />
                        <span className="text-xl font-bold text-light-primary">کدپرو</span>
                    </Link>
                </Wrapper>
            </header>
            {/* Push the content down when sticky */}
            <div className={`${isSticky ? 'h-[72px]' : ''}`}></div>
        </>
    );
};

export default Header;
